// this file is shared frontend and backend
// export const AUPRED_PROMPT_FUNC = (botName) => `The following is a webcam photo:` // gpt recommends non-empty to avoid llm repetition
export const AUPRED_PROMPT_FUNC = (botName) => `להלן תמונה שנקלטה במצלמת הרשת:` // gpt recommends non-empty to avoid llm repetition

